/**
 * /eric/notifications — operator notification feed.
 *
 * The operator-side counterpart to /portal/notifications. The notifications
 * table is RLS-scoped to recipient_user_id = auth.uid(), so the same
 * fetchOwnNotifications read returns Eric's operator-addressed rows
 * (input_submitted, and the migration-0011/0016 operator-only types). This is
 * the destination the top-bar bell links to so the unread count is finally
 * clickable.
 *
 * Route config only. Component lives in eric.notifications.lazy.tsx
 * (code-split). The parent /eric layout route gates on requireOperatorEntry.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/notifications')({});
